import Vue from 'vue'
import Router from 'vue-router'

const routerOptions = [

  // ================================================ Root =======================================================
  { path: '/', name: 'Home', componentPath: 'Home' },

  // ================================================ Tickets =====================================================
  {path: "/ticketdetails/:id?", name:'TicketsList', componentPath:'Tickets/Tab'},
  {path: "/pm/ticketdetails/:id?", name:'PMTicketsList', componentPath:'Tickets/Tab'},
  {path:'/tickets/create/', name:'TicketsCreate', componentPath:'Tickets/CreateTicket'},
  {path:'/ticketdetails/edit/:id?', name:'TicketsEdit', componentPath:'Tickets/EditTicket'},
  {path:'/ticketdetails/view/:id', name:'ViewRedirectedTicket', componentPath:'Tickets/EditTicket'},
  {path:'/tickets/create/service/:id', name:'TicketsServiceCreate', componentPath:'Tickets/CreateTicket'},
  {path:'/tickets/create/product', name:'ProductTemplate', componentPath:'Tickets/ProductTemplate'},
  // {path:'/tickets/details/:id', name:'TicketDetails', componentPath:'Tickets/TicketDetails'},
  {path: "/ticketdetails/:comp_id/:user_id/:id", name:'TicketViewSwitchCompany', componentPath:'Tickets/TicketViewSwitchCompany'},

  // ================================================ Archieve =====================================================
  {path: "/archievetickets/:id?", name:'ArchieveListView', componentPath:'ArchieveTickets/ArchieveTab'},

  // ================================================ Settings =====================================================
  { path: '/settings', name: 'Settings', componentPath: 'SettingsModule/Settings'},

  // ================================================ Notifications =====================================================
  { path: '/notifications', name: 'AllNotifications', componentPath: 'Notification/AllNotifications'},
  { path: '/notifications_page', name: 'NotificationsPage', componentPath: 'Notification/ShowAllNotifications'},

  // ================================================ Access Denied =======================================================
  { path: '/subscription', name: 'AccessDenied', componentPath: 'AccessDenied'},

  // ================================================= Login ==============================================================
  // {path:'/login', name:'Login', componentPath:'NewTheme/Login'},
  {path:'/login', name:'Login', componentPath:'Login/LoginLibrary'},


  // ================================================= OTP ==============================================================
  {path:'/verifyOtp', name:'VerifyOtp', componentPath:'VerifyOtp'},

  // ================================================= Facility Management ==============================================================
  {path:'/facilitymanagement/listview', name:'FacilityManagement', componentPath:'FacilityManagement/ListView'},
  {path:'/facilitymanagement/securityconcern/create', name:'CreateSecurityConcern', componentPath:'NewTheme/CreateSecurityConcernNew'},
  {path:'/facilitymanagement/securityconcern/view/:id', name:'ViewSecurityConcern', componentPath:'FacilityManagement/CreateSecurityConcern'},

  // ================================================= Dynamic Template ==============================================================
  {path:'/dynamictemplate/create', name:'CreateDynamicTemplate', componentPath:'SettingsModule/TemplatesNew/CreateTemplate'},
  {path:'/dynamictemplate/edit/:id', name:'EditDynamicTemplate', componentPath:'SettingsModule/TemplatesNew/CreateTemplate'},
  {path:'/dynamictemplate/view/:id', name:'ViewDynamicTemplate', componentPath:'SettingsModule/TemplatesNew/ViewTemplate'},
  {path:'/dynamictemplate/preview/:id', name:'PreviewDynamicTemplate', componentPath:'SettingsModule/TemplatesNew/PreviewTemplate'},


 ]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.componentPath}.vue`)
  }
})

Vue.use(Router)

export default new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history'
})
